import React, {useEffect, useCallback} from 'react';
import b_ from 'b_';

import {useModal} from 'client/common/hooks/modal';
import {CreativesBoxType} from 'client/creatives/types';

import WelcomeModal from './welcome-modal';

import './onboarding.css';

const b = b_.with('onboarding');

interface OnboardingProps {
    visible: boolean;
    boxName: CreativesBoxType;
    onShowWelcome?: () => void;
}

export default function Onboarding({visible, boxName, onShowWelcome = () => {}}: OnboardingProps) {
    const [showModal, hideModal] = useModal();

    const onClickWelcomeClose = useCallback(() => {
        hideModal();
    }, [hideModal]);

    const showWelcomeModal = useCallback(() => {
        onShowWelcome();

        showModal(
            <WelcomeModal
                className={b('welcome-modal')}
                onClose={onClickWelcomeClose}
                boxName={boxName}
            />,
            {
                className: b('welcome-modal-wrapper'),
                withCross: true
            }
        );
    }, [showModal, onClickWelcomeClose, boxName, onShowWelcome]);

    useEffect(() => {
        if (!visible) {
            return;
        }

        showWelcomeModal();
    }, [showWelcomeModal, visible]);

    return null;
}
